<template>
	<Page>
		<div class="centered">
			<router-link :to="{name:'templates'}" >&lsaquo; Back</router-link>
			<h1>Create a new template</h1>
			<div class="raised-box p-box s-above">

				<SimpleForm
						:onSubmit="onSubmit"
						:fields="[
							{
								label : 'Template name',
								name : 'name',
								autocomplete : 'template-name',
								autofocus : true,
								required : true,
								// label_help : 'Accepts alphanumeric characters and underscores.',
							},
							{
								label : 'Organisation',
								name : 'org_id',
								type : 'org',
								required : true,
							},
							{
								label : 'Template',
								name : 'templateData',
								type : 'template',
								autofocus : true,
								required : true,
								// label_help : 'Accepts alphanumeric characters and underscores.',
							},
						]"
						submitText="Create Template"
					/>

			</div>
		</div>

	</Page>
</template>

<script>

	import Page from '../mixins/Page'

	export default {
		mixins : [Page],

		methods:{
			onSubmit(payload){
				var self = this;
				payload.template = payload.templateData.body;
				payload.variables = payload.templateData.variables;

				return api.store('template',payload)
						.then((template)=>{
							self.$router.push({name:'template',params:{template_id:template.id}});
						})
			},
		},
	}

</script>